/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceContact } from './SourceContact';
import {
    SourceContactFromJSON,
    SourceContactFromJSONTyped,
    SourceContactToJSON,
    SourceContactToJSONTyped,
} from './SourceContact';

/**
 * 
 * @export
 * @interface FindAllSourceContactsResponse
 */
export interface FindAllSourceContactsResponse {
    /**
     * 
     */
    data: Array<SourceContact>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllSourceContactsResponse interface.
 */
export function instanceOfFindAllSourceContactsResponse(value: object): value is FindAllSourceContactsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FindAllSourceContactsResponseFromJSON(json: any): FindAllSourceContactsResponse {
    return FindAllSourceContactsResponseFromJSONTyped(json, false);
}

export function FindAllSourceContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceContactsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SourceContactFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllSourceContactsResponseToJSON(json: any): FindAllSourceContactsResponse {
    return FindAllSourceContactsResponseToJSONTyped(json, false);
}

export function FindAllSourceContactsResponseToJSONTyped(value?: FindAllSourceContactsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(SourceContactToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

